export const enterNumberPrompt = 'Введите номер<br /> телефона, указанный<br /> при регистрации';
export const incorrectNumberErrText = 'неправильный номер';
export const phoneRegTooltipText = 'Если вы забудете пароль,<br /> мы отправим вам SMS<br /> с напоминанием';
export const phoneVerifiedText = 'Номер телефона успешно подтвержден.';



/** WEBPACK FOOTER **
 ** ./src/texts.js
 **/